module.exports = __webpack_public_path__ + "static/media/content-8.2c51c485.svg";